import { Box, Typography, useTheme } from '@mui/material';
import type { FC } from 'react';

interface Props {
  label: string;
  value: JSX.Element[] | JSX.Element | string | undefined;
}

export const DisplayField: FC<Props> = ({ label, value }) => {
  const theme = useTheme();
  return (
    <Box>
      <Typography
        sx={{
          color: theme.palette.text.disabled,
          fontSize: '0.75rem',
          transform: 'translate(0, -6px)',
        }}
      >
        {label}
      </Typography>
      <Typography component="span">{value}</Typography>
    </Box>
  );
};
